export const categories = [
  { slug: 'anime', name: '动漫资源', icon: 'ri-movie-2-line', description: '热门新番、经典番剧、剧场版动画资源合集', color: 'accent' },
  { slug: 'manga', name: '漫画资源', icon: 'ri-book-open-line', description: '日漫、国漫、韩漫等各类漫画资源', color: 'primary' },
  { slug: 'game', name: '游戏资源', icon: 'ri-gamepad-line', description: 'Galgame、RPG、视觉小说等游戏资源', color: 'secondary' },
  { slug: 'light-novel', name: '轻小说', icon: 'ri-file-text-line', description: '日系轻小说、Web小说等文字资源', color: 'accent' },
  { slug: 'music', name: '音乐资源', icon: 'ri-music-2-line', description: '动漫OST、角色歌、Vocaloid等音乐资源', color: 'primary' },
  { slug: 'wallpaper', name: '壁纸图包', icon: 'ri-image-2-line', description: '高清动漫壁纸、画师图包、官方视觉图', color: 'secondary' },
];

export const categoryStats = {
  anime: { count: 1286, today: 23 },
  manga: { count: 965, today: 15 },
  game: { count: 543, today: 8 },
  'light-novel': { count: 821, today: 12 },
  music: { count: 432, today: 6 },
  wallpaper: { count: 1890, today: 31 },
};